import {
    GET_SURVEY_SUCCESS,
    GET_SURVEY_FAILURE,
} from '../actions/SurveyActions';

const initialState = {
    surveyQuestionsData: null,
};

export const surveyReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SURVEY_SUCCESS: {
            return {
                ...state,
                surveyQuestionsData: action.surveyQuestionsData,
            };
        }

        case GET_SURVEY_FAILURE: {
            return {
                ...state,
                surveyQuestionsData: {},
            };
        }

        default: {
            return {
                ...state,
            };
        }
    }
};
